import { createContext, ReactNode, useContext, useState } from "react";

type GenericList<T> = {
  items: T[];
  add: (item: T) => void;
  remove: (predicate: (item: T) => boolean) => void;
};

const SelectedItemsContext = createContext<GenericList<any>>(undefined as any);

export const SelectedItemsProvider = <T,>({ children }: { children: ReactNode | ReactNode[] }) => {
  const [items, setItems] = useState<T[]>([]);

  function add(item: T) {
    setItems((prev) => [...prev, item]);
  }

  function remove(predicate: (item: T) => boolean) {
    setItems((prev) => prev.filter((item) => !predicate(item)));
  }

  return <SelectedItemsContext.Provider value={{ items, add, remove }}>{children}</SelectedItemsContext.Provider>;
};

export function useSelectedItems<T>() {
  const context = useContext<GenericList<T>>(SelectedItemsContext);

  return context as GenericList<T>;
}
